<template>
  <div class="">

    <!-- 		<div class="coupon-tips" @click.stop="changeCouponVisible">
			如何获得优惠券?
		</div>

		<el-dialog title="提示" :visible.sync="couponVisible" width="30%" :append-to-body="true" @close="chargeclose">
			<div class="tips-box">
				<p>如何获得优惠券</p>
				<p>1、每周一抽盲盒，可获得5-200元不等的优惠券</p>
				<p>2、充值不同金额，直接送5-220元优惠券；<a href="javascript;"></a></p>
				<p>1、每周一抽盲盒，可获得5-200元不等的优惠券</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="couponVisible = false">取 消</el-button>
				<el-button type="primary" @click="couponVisible = false">确 定</el-button>
			</span>
		</el-dialog> -->

    <el-tabs :loading="loading">
      <el-tab-pane label="有效优惠券">
        <span slot="label">有效优惠券({{effecttiveCount}})</span>
        <div class="coupon" v-if="effecttiveCoupon.length > 0">
          <div v-for="item in effecttiveCoupon" :key="item.id" class="coupon-item"
            :style="'background-image:url('+effectback+')'">
            <div class="coupon-left">

              <span>¥{{item.money}}</span>
            </div>
            <div class="coupon-right">
              <p class="text_a">{{item.title}}</p>

              <p class="text_b">{{item.takeeffectTime}}至{{item.invalidTime}}</p>
              <p class="text_c">{{item.mark}}</p>
            </div>
          </div>
        </div>
        <div v-if="effecttiveCoupon.length > 0">
          <el-pagination background layout="prev, pager, next" :total="effecttiveCount" :page-size="effecttivePageSize"
            :current-page="effecttivePageindex" @current-change="effecttivePage"></el-pagination>
        </div>
        <div v-if="effecttiveCoupon.length == 0">
          <el-empty description="暂无优惠卷"></el-empty>
          <el-button type="primary" @click="getmoreEffectCoupon">获取更多优惠券</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已使用优惠券">
        <span slot="label">已使用优惠券（{{usedCount}}）</span>

        <div class="coupon">
          <div v-for="item in usedCoupon" :key="item.id" class="coupon-item"
            :style="'background-image:url('+usedback+')'">
            <div class="coupon-left">

              <span>¥{{item.money}}</span>
            </div>
            <div class="coupon-right">
              <p class="text_a">{{item.title}}</p>

              <p class="text_b">{{item.takeeffectTime}}至{{item.invalidTime}}</p>
              <p class="text_c">{{item.mark}}</p>
            </div>
          </div>
        </div>
        <div v-if="usedCoupon.length > 0">
          <el-pagination background layout="prev, pager, next" :total="usedCount" :page-size="usedPageSize"
            :current-page="usedPageindex" @current-change="usedPage"></el-pagination>
        </div>
        <div v-if="usedCoupon.length == 0">
          <el-empty description="暂无优惠卷"></el-empty>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已过期优惠券">
        <span slot="label">已过期优惠券({{outTimeCount}}）</span>
        <div class="coupon">
          <div v-for="item in outTimeCoupon" :key="item.id" class="coupon-item"
            :style="'background-image:url('+outTimeback+')'">
            <div class="coupon-left">

              <span>¥{{item.money}}</span>
            </div>
            <div class="coupon-right">
              <p class="text_a">{{item.title}}</p>

              <p class="text_b">{{item.takeeffectTime}}至{{item.invalidTime}}</p>
              <p class="text_c">{{item.mark}}</p>
            </div>
          </div>
        </div>
        <div v-if="outTimeCoupon.length > 0">
          <el-pagination background layout="prev, pager, next" :total="outTimeCount" :page-size="outTimePageSize"
            :current-page="outTimePageindex" @current-change="outTimePage">
          </el-pagination>

        </div>
        <div v-if="outTimeCoupon.length == 0">
          <el-empty description="暂无优惠卷"></el-empty>
        </div>
      </el-tab-pane>


      <!--    <recharge :rechargeBack="rechargecallback" :dialogVisible="dialogvisible" @chargeclose="dialogclose">
		    </recharge> -->
    </el-tabs>

  </div>


</template>

<script>
  import recharge from '../../components/Recharge/recharge.vue'
  export default {
    data() {
      return {
        effecttiveCoupon: [],
        effecttiveCount: 0,
        effecttivePageindex: 1,
        effecttivePageSize: 10,
        usedCoupon: [],
        usedCount: 0,
        usedPageindex: 1,
        usedPageSize: 10,
        outTimeCoupon: [],
        outTimeCount: 0,
        outTimePageindex: 1,
        outTimePageSize: 10,
        effectback: "https://vias2019.oss-cn-shenzhen.aliyuncs.com/browser-upload-file/a5b7c280-0926-4d93-acc0-aee4f6c939de.png",
        usedback: "https://vias2019.oss-cn-shenzhen.aliyuncs.com/browser-upload-file/2bf66949-ddb0-40e5-aefc-50e555e84146.png",
        outTimeback: "https://vias2019.oss-cn-shenzhen.aliyuncs.com/browser-upload-file/2bf66949-ddb0-40e5-aefc-50e555e84147.png",
        loading: false,
        couponVisible: false,
      }
    },
    components: {
      recharge
    },
    created() {
      this.getEffectCoupon()
      this.getusedCoupon()
      this.getexpiredCoupon()
    },
    methods: {
      chargeclose() {

      },
      changeCouponVisible() {
        this.couponVisible = !this.couponVisible;
      },

      getmoreEffectCoupon() {
        this.$emit('getmoreEffectCoupon')
      },
      dialogclose() {
        this.$emit('dialogclose')
      },
      rechargecallback() {
        this.dialogclose();
        this.getEffectCoupon();
      },
      getEffectCoupon() {
        this.loading = true
        this.$api.GetAllEffectiveCoupon({
          pagesize: this.effecttivePageSize,
          pageindex: this.effecttivePageindex
        }).then(res => {
          if (res.data.status == 200) {
            this.effecttiveCoupon = res.data.data.DataList || []
            this.effecttiveCount = res.data.data.TotalCount || 0
            this.loading = false
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      getusedCoupon() {
        this.loading = true
        this.$api.GetAllInvalidCouponNew({
          pagesize: this.usedPageSize,
          pageindex: this.usedPageindex
        }).then(res => {
          if (res.data.status == 200) {
            this.usedCoupon = res.data.data.DataList || []
            this.usedCount = res.data.data.TotalCount || 0
            this.loading = false
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      getexpiredCoupon() {
        this.loading = true
        this.$api.GetAllExpiredCoupon({
          pagesize: this.outTimePageSize,
          pageindex: this.outTimePageindex
        }).then(res => {
          if (res.data.status == 200) {
            this.outTimeCoupon = res.data.data.DataList || []
            this.outTimeCount = res.data.data.TotalCount || 0
            this.loading = false
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      effecttivePage(index) {
        this.effecttivePageindex = index
        this.getEffectCoupon()
      },
      usedPage(index) {

        this.usedPageindex = index
        this.getusedCoupon()
      },
      outTimePage(index) {
        this.outTimePageindex = index
        this.getexpiredCoupon()
      }
    }
  }

</script>

<style lang="less" scoped>
  .coupon {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow: auto;
    align-items: flex-start;
    align-content: flex-start;

    .coupon-item {
      height: 93px;
      border: 1px solid #333;
      border-radius: 4px;
      margin: 10px 10px;

      background-size: cover;
      display: flex;
      width: 360px;

      .coupon-left {
        width: 30%;
        line-height: 93px;
        color: #fff;
        font-size: 28px;
        text-align: center;

        span {
          font-size: 24rpx
        }
      }

      .coupon-right {
        flex: 1;
        padding: 0px 20px;
        text-align: left;

        .text_a {
          font-size: 20px;
          color: #636363;
          line-height: 10px;
          margin: 20px 0px;
        }

        .text_b,
        .text_c {
          font-size: 12px;
          color: #acacac;
          line-height: 5px;
          margin: 10px 0px;
        }

        .text_c {
          line-height: 16px;
          border-top: 1px solid #434343;
          line-height: 20px;
        }
      }
    }

    .active {
      border: 2px solid #ff6223;
      box-shadow: 1px 1px 10px #ff6223;
    }
  }

  .coupon-tips {
    position: absolute;
    top: 0.625rem;
    font-size: 0.875rem;
    right: 35%;
    color: #e12345;
    cursor: pointer;
    z-index: 1000;
  }

  .tips-box {
    width: 90%;
    margin: 0 auto;
    background-color: #f7f8fa;
  }

</style>



// WEBPACK FOOTER //
// src/page/personcenter/coupon.vue